'use strict';

// Slide to section links
$('.js_link').on('click', function(e) {
  e.preventDefault();

  let headerHeight = 0;

  if ($(window).width() < 768) {
    headerHeight = $('.header-sp').height();
    headerHeight -= 5;
  } else {
    headerHeight = $('.header-pc').height();
    headerHeight -= 10;
  }

  const target = $(this).attr('href');
  const offset = $(target).offset().top - headerHeight;

  $('html,body').animate({scrollTop: offset}, 700);

  return 0;
});

// Show and hide global navigation on scroll
{
  const slideDownNav = {
    el: {
      headerEls: document.querySelectorAll('.js_header'),
      headerClass: '.js_header',
      activateSectionClass: '.js_header-activate'
    },

    config: {
      active: false
    },

    init() {
      this.toggleNav(window.scrollY);
      this.scrollHandler();
    },

    scrollHandler() {
      const _this = this;

      let lastKnownScrollPosition = 0;
      let ticking = false;

      function doWhileScrolling(scrollPos) {
        _this.toggleNav(scrollPos);
      }

      document.addEventListener('scroll', function () {
        lastKnownScrollPosition = window.scrollY;

        if (!ticking) {
          window.requestAnimationFrame(function () {
            doWhileScrolling(lastKnownScrollPosition);
            ticking = false;
          });

          ticking = true;
        }
      });
    },

    toggleNav(scrollPos) {
      // Get activate position
      const activateElementPos = document.querySelector(
        this.el.activateSectionClass
      ).offsetTop;
      const headerHeight = document.querySelector(
        this.el.headerClass
      ).offsetHeight;
      const activatePos = activateElementPos - headerHeight;

      // Activate header
      if (scrollPos >= activatePos && this.config.active !== true) {
        if (this.config.active !== true) {
          this.slideDown();

          this.config.active = true;
        } else {
          this.slideDown();
        }

        this.config.active = true;
      }

      // Deactivate header
      if (scrollPos < activatePos && this.config.active !== false) {
        this.slideUp();

        this.config.active = false;
      }
    },

    slideDown() {
      this.el.headerEls.forEach(function (headerEl) {
        headerEl.classList.add('active');
      });
    },

    slideUp() {
      this.el.headerEls.forEach(function (headerEl) {
        headerEl.classList.remove('active');
      });
    }
  };

  // Only enable the sticky dropdown navigation on the top page
  if (document.querySelector('.js_header')) {
    slideDownNav.init();
  }
}

// Hamburger menu
{
  const hbMenu = {
    el: {
      headerLogoEl: document.querySelector('.nav-sp__logo'),
      menuEl: document.querySelector('.js_nav-sp'),
      openBtnEl: document.querySelector('.js_nav-sp-open'),
      closeBtnEl: document.querySelector('.js_nav-sp-close'),
      navLinkEls: document.querySelectorAll('.js_nav-sp .js_link')
    },

    init() {
      this.openHandler();
      this.closeHandler();
      this.linkHandler();
    },

    openHandler() {
      this.el.openBtnEl.addEventListener('click', (event) => {
        event.preventDefault();
        this.openMenu();
        return 0;
      });
    },

    closeHandler() {
      this.el.closeBtnEl.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeMenu();
        return 0;
      });
    },

    openMenu() {
      this.el.menuEl.classList.add('active');
      this.el.headerLogoEl.classList.add('inactive');
    },

    closeMenu() {
      this.el.menuEl.classList.remove('active');
      this.el.headerLogoEl.classList.remove('inactive');
    },

    linkHandler() {
      this.el.navLinkEls.forEach((navLink) => {
        navLink.addEventListener('click', (event) => {
          this.closeMenu();
        });
      });
    }
  };

  if (document.querySelector('.js_nav-sp')) {
    hbMenu.init();
  }
}

// Animations
{
  const animations = {
    el: {
      animatedBlock: '.js_animated',
      animatedBlockSection: '.js_animated-section',
      $animatedBlockSections: $('.js_animated-section'),
      $introSection: $('.js_animated-intro')
    },

    config: {},

    init() {
      this.animateIntro();
      this.animateText();
    },

    animateText() {
      const _this = this;

      const addAnimation = function (blockSectionNum) {
        // Trigger offset
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();

        let triggerOffset = -(windowHeight / 2) * 0.5;
        if (windowWidth <= 767) {
          if (blockSectionNum <= 3) {
            triggerOffset = -(windowHeight / 2) * 0.6;
          } else {
            triggerOffset = -(windowHeight / 2) * 0.4;
          }
        }

        // init controller
        const controller = new ScrollMagic.Controller();

        // build scene
        const scene = new ScrollMagic.Scene({
          triggerElement: `${_this.el.animatedBlockSection}${blockSectionNum}`,
          reverse: false,
          offset: triggerOffset
        })
          .setClassToggle(
            `${_this.el.animatedBlockSection}${blockSectionNum} ${_this.el.animatedBlock}`,
            'animated--active'
          )
          //.addIndicators({name: blockSectionNum}) // add indicators (requires plugin)
          .addTo(controller);
      };

      const numAnimatedSections = _this.el.$animatedBlockSections.length;

      // Set scene for each of the animated text areas
      for (let i = 0; i < numAnimatedSections; i++) {
        addAnimation(i + 1);
      }
    },

    animateIntro() {
      setTimeout(() => {
        this.el.$introSection.addClass('animated--active');
      }, 500);
    }
  };

  animations.init();
}

// Success stories slider
{
  const storiesSlider = {
    el: {
      sliderEl: document.querySelector('.js_testimonialsSlider')
    },

    init() {
      this.runSlider();
    },

    runSlider() {
      const glide = new Glide(this.el.sliderEl, {
        type: 'carousel',
        perView: 1.3,
        focusAt: 'center',
        gap: 5,
        animationDuration: 1000,
        autoplay: false,
        keyboard: true,
        breakpoints: {
          767: {
            perView: 1
          }
        }
      });

      glide.mount();
    }
  };

  if (document.querySelector('.js_testimonialsSlider')) {
    storiesSlider.init();
  }
}